<template>
  <div class="index-wrapper">
    <div class="left-wrapper" id="robot-panel" ref="robotDom"
      :class="{ 'isMobile': isMobile, 'expendRobot': !foldRobot }">
      <chat-robot />
      <!-- <div class="touch-div" ref="moveDom">
        <span></span>
        <span></span>
      </div> -->
    </div>
    <div class="right-wrapper">
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>

    <img class="avatar user-avatar" v-if="isMobile" slot="reference" :src="userUrl" @click="handleInfoShow" />
    <el-popover v-if="!isMobile" popper-class="user-popover" placement="bottom-end" trigger="hover" width="280"
      :visible-arrow="false">
      <info-card from="">

      </info-card>

      <img class="user-avatar" slot="reference" :src="userUrl" />
    </el-popover>
    <user-info v-if="isShow" @handleInfoShow="handleInfoShow">

    </user-info>
  </div>
</template>

<script>
import userUrl from "@/assets/image/user.svg";
import "element-ui/lib/theme-chalk/display.css";
import ChatRobot from "../../components/chat/chatRobot.vue";
import InfoCard from "../../components/user/InfoCard.vue";
import UserInfo from "@/components/mobile/user.vue"
import { mapState } from "vuex";
import { isMobile } from "../../utils/deviceDetector";

export default {
  name: "App",
  components: { ChatRobot, InfoCard, UserInfo },
  data() {
    return {
      clientStartX: 0,
      userUrl,
      isShow: false,
    };
  },
  computed: {
    ...mapState(["foldRobot", "isMobile"]),
  },
  methods: {
    handleInfoShow() {
      this.isShow = !this.isShow
    },

    handleClick() {
      console.log("点击了");
      dialogVisible = true;
    },


    // 分割线的拖拽
    handleDragDivide() {
      this.letfDom = this.$refs.robotDom;
      let moveDom = this.$refs.moveDom;
      moveDom.onmousedown = (e) => {
        this.clientStartX = e.clientX;
        e.preventDefault();
        document.onmousemove = (e) => {
          this.moveHandle(e.clientX, this.letfDom);
        };

        document.onmouseup = (e) => {
          document.onmouseup = null;
          document.onmousemove = null;
        };
      };
    },
    moveHandle(nowClientX, letfDom) {
      let computedX = nowClientX - this.clientStartX;
      let leftBoxWidth = parseInt(letfDom.clientWidth);
      let changeWidth = leftBoxWidth + computedX;
      // if (changeWidth < 120) {
      //   changeWidth = 0;

      // }

      if (changeWidth > 280) {
        changeWidth = 280;
      }

      letfDom.style.width = changeWidth + "px";

      this.clientStartX = nowClientX;
    },
    // handlScroll(immediate = false) {
    //   const ele = this.$refs.chatRecord.$el.querySelectorAll(".chat-message");
    //   if (immediate) {
    //     ele && ele[ele.length - 1].scrollIntoView();
    //     return;
    //   }
    //   this.$nextTick(() => {
    //     //不能直接用 ele  nextTick会重新更新，ele是上一轮的缓存
    //     const nextEle =
    //       this.$refs.chatRecord.$el.querySelectorAll(".chat-message");
    //     nextEle[nextEle.length - 1]
    //       ? nextEle[nextEle.length - 1].scrollIntoView()
    //       : "";
    //   });
    // },

  },
};
</script>
<style lang="scss" scoped>
html {
  // font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
  //   Microsoft YaHei, SimSun, sans-serif;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
}

/* 一般浏览器的不要太小，容易看不见 */

.index-wrapper {
  display: flex;
  margin: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;

  .right-wrapper {
    flex: 1;
    // z-index: 2;
  }


  .touch-div {
    position: absolute;
    top: 0;
    left: 98%;
    height: 100vh;
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: col-resize;

    span {
      width: 2px;
      background: #bbb;
      margin: 0 2px;
      height: 15px;
    }
  }
}

.hint {
  display: flex;

  .hint-img {
    padding-right: 12px;
  }

  span {
    line-height: 24px;
  }
}

.user-avatar {
  position: absolute;
  right: 1.5rem;
  top: 1rem;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 100;
  // position: fixed;
  width: 30px;
}




.isMobile.expendRobot {
  position: absolute;
}
</style>
<style lang="scss">
.el-popover.theme-popover {
  min-width: 120px;
  box-sizing: border-box;
  position: absolute;
  margin: 0;
  padding: 4px;
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  background-color: var(--bg-color-4);
}

.el-popover.user-popover {
  padding: 0 !important;
  border-radius: 16px !important;
  margin-right: 20px !important;
}

@media (max-width:1024px) {

  .user-avatar {
    width: 30px !important;
    max-width: 35px;
    height: 30px !important;
    max-height: 35px;
    top: 0.1rem !important;
    right: 0.1rem !important;
    // position: fixed;
    // z-index: 100;
  }


}
</style>
